import notification from 'epn-ui/umd/dist/components/Notification';
import BaseCopyableLink from '@components/base/BaseCopyableLink';

interface IAffiliateCopyable {
    label: string;
    text: string;
    error?: string;
    id?: string;
    description?: string;
}

const AffiliateCopyable: React.FC<IAffiliateCopyable> = ({
    label,
    text,
    id,
    error,
    description = '',
}) => {
    if (error) {
        notification.error({ message: error, className: 'errorNotification' });
    }
    return (
        <div className="p-6 border border-t border-blueGray-200 rounded-2">
            <BaseCopyableLink label={label} text={text} id={id} description={description} />
        </div>
    );
};

export default AffiliateCopyable;
